import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { PartnerConnectLoadSpinCommand } from "partner-connect/commands/partner-connect-load-spin-command";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { RequestSpin } from "slotworks/state-machine/standard/states/request-spin";

export class PartnerConnectRequestSpin extends RequestSpin {

    public onEnter(cascadeSkip?: boolean) {
        new Sequence([
            () => Contract.wrapPromise(PartnerConnectManager.getEmitters()?.gameRoundStarted()),
            () => Contract.wrapPromise(PartnerConnectManager.getEmitters()?.spinStarted()),
            () => Contract.wrap(() => super.onEnter(cascadeSkip))
        ]).execute();
    }

    protected startSpinning(): Contract<any> {
        return new Parallel([
            () => StartSpinCommand(),
            () => PartnerConnectLoadSpinCommand()
        ]);
    }
}
